<template>
  <div>
    <vx-card collapse-action refresh-content-action @refresh="closeCardAnimationDemo" title="Activity Reports">
      <div class="flex flex-col gap-12">

        <div class="flex items-center space-x-4 justify-between">

          <div class="flex w-s items-center border border-solid rounded-lg border-black px-3 py-2">
            <calendar-icon class="mr-2 w-5" />
            <span>{{ formatDateRange() }}</span>
          </div>


          <div class="flex gap-8">
            <vs-button @click="swapTable()">
              {{ swapTableName }}
            </vs-button>

            <vs-input v-model="searchQuery" @input='search' placeholder="Search..." class="border rounded-lg" />
          </div>
        </div>

        <DriverTable @open="changeModalOpen(true)" v-if="swapTableName === 'By vehicle'" :tableData="table" />

        <VehicleTable @open="changeModalOpen(true)" v-else-if="swapTableName === 'By driver'" :tableData="table" />

      </div>
    </vx-card>

    <InfoModal v-show="modalOpen" :tableData="detailTableData" @cancel="changeModalOpen(false)" />
  </div>
</template>

<script>
import { CalendarIcon } from 'vue-feather-icons';
import moment from 'moment';
import VehicleTable from './components/VehicleTable/VehicleTable'
import DriverTable from './components/DriverTable/DriverTable'
import InfoModal from './components/InfoModal/InfoModal'

export default {
  components: {
    CalendarIcon,
    VehicleTable,
    DriverTable,
    InfoModal
  },
  data() {
    return {
      searchQuery: '',
      swapTableName: 'By driver',
      driverTable: [
        {
          name: 'Kaldarkhan Shukirbaev',
          odometer: '5180',
          time: '0',
        },
        {
          name: 'Kaldarkhan Shukirbaev',
          odometer: '5180',
          time: '0',
        },
        {
          name: 'Kaldarkhan Shukirbaev',
          odometer: '5180',
          time: '0',
        },
        {
          name: 'Kaldarkhan Shukirbaev',
          odometer: '5180',
          time: '0',
        }
      ],
      modalOpen: false,
      currentTable: 'vehicle'
    };
  },
  computed: {
  },
  methods: {
    formatDateRange() {
      const today = moment();
      const lastWeek = moment().subtract(7, 'days');
      return `${lastWeek.format('MM-DD-YYYY')} → ${today.format('MM-DD-YYYY')}`;
    },
    swapTable() {
      const name = this.swapTableName === 'By driver' ? 'By vehicle' : "By driver"
      const type = name === 'By driver' ? 'vehicle' : "driver"
      this.currentTable = type
      this.loadData({ type: type })
      return this.swapTableName = name;
    },
    changeModalOpen(value) {
      this.modalOpen = value;
    },
    closeCardAnimationDemo(card) {
      card.removeRefreshAnimation(3000);
      setTimeout(() => {
        this.loadData({ type: this.currentTable, search: this.searchQuery });
      }, 3000);
    },
    search() {
      if (!this.searchQuery) {
        this.loadData({ type: this.currentTable })
        return
      }
      this.loadData({ type: this.currentTable, search: this.searchQuery })

    },
    loadData(query = {}) {
      this.$store.dispatch('activityReports/fetchTable', query)
    }
  },
  created() {
    this.$store.dispatch('activityReports/fetchTable', { type: 'vehicle' })
  },
  computed: {
    table() {
      return this.$store.state.activityReports.table;
    },
    detailTableData() {
      const tableData = this.$store.state.activityReports.table;
      const data = tableData.vehicles && tableData.vehicles.length ? tableData.vehicles : tableData.drivers
      return data
    }
  },
};
</script>

<style scoped>
/* Add any additional styles you need */
</style>
